export const Breakpoints = {
  mobile: "(max-width: 767px)",
  tablet: "(max-width: 960px)",
} as const;
